import apiClient, { safeJson } from '@/api/client';
import { MergePreviewResponse, MergeExecuteBody, MergeExecuteResponse } from './types';

export const getMergePreview = async (tempMemberId: string, originalMemberId: string) => {
    const res = await apiClient.get(`v1/members/merge/preview/${tempMemberId}/${originalMemberId}`);
    const data = await safeJson(res);
    return { status: res.status, data: data as MergePreviewResponse | null };
};

export const executeMerge = async (body: MergeExecuteBody) => {
    const res = await apiClient.post('v1/members/merge', { json: body });
    const data = await safeJson(res);
    return { status: res.status, data: data as MergeExecuteResponse | null };
};
